import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import InputBox from 'src/common/refactoredComponents/input/Input';
import { PatientRowDiv } from 'src/pages/scheduleSurgery/components/details/Details.styled';

export const LastNameRow = styled(PatientRowDiv)`
    ${media.mobileDevice`
        display: grid;
        grid-template-columns: minmax(0, 3fr) minmax(0, 1fr);
        gap: 10px;

        > input {
            box-sizing: border-box;
            min-width: 0;
            width: 100%;
            margin-left: 0;
            margin-right: 0;
        }
    `}
`;

export const LastNameInput = styled(InputBox)`
    ${media.mobileDevice`
        position: relative;
        z-index: 99999 !important;
    `}
`;

export const SubTitleComponent = styled.p`
    font-family: 'AvenirNextWorld Demi';
    font-size: 20px;
    align-content: 'left';
    color: #140f4b;
`;
export const SpaceDiv = styled.div`
    ${media.mobileDevice`
    width:18px;
`}
`;
